import { create } from 'zustand';

import { IUser } from '@shared/types';

const AUTH_STORAGE_KEY = 'user';

export interface ILoginResponse {
  userInfo: IUser;
  accessToken: string;
}

interface UserState {
  user: ILoginResponse | null;
  isInitializing: boolean;
  setLoginSuccessResponse: (user: ILoginResponse) => void;
  hydrateFromStorage: () => void;
  setAccessToken: (accessToken: string) => void;
  clearAuth: () => void;
  setInitializing: (value: boolean) => void;
}

export const useUserStore = create<UserState>()(set => ({
  user: null,
  isInitializing: true,

  setLoginSuccessResponse: user => {
    set({ user });
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
  },

  hydrateFromStorage: () => {
    const storedUser = localStorage.getItem(AUTH_STORAGE_KEY);

    if (!storedUser) {
      set({ user: null });
      return;
    }

    try {
      const user = JSON.parse(storedUser) as ILoginResponse;
      set({ user });
    } catch (error) {
      localStorage.removeItem(AUTH_STORAGE_KEY);
      set({ user: null });
    }
  },

  setAccessToken: accessToken => {
    set(state => {
      if (!state.user) {
        return { user: state.user };
      }

      const nextUser = {
        ...state.user,
        accessToken,
      };

      localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(nextUser));

      return { user: nextUser };
    });
  },

  clearAuth: () => {
    set({ user: null });
    localStorage.removeItem(AUTH_STORAGE_KEY);
  },

  setInitializing: value => {
    set({ isInitializing: value });
  },
}));
